/**
 * PrintingReportButton component
 * Opens pre-generated CSV report from reportUrl field
 * Matches hardware-digester functionality where machines upload reports to external storage
 *
 * Features:
 * - Uses reportUrl field from Printing record
 * - Opens report in new tab
 * - Only shows button if reportUrl exists
 */

import { useRecordContext } from 'react-admin';
import { Button, InputLabel, Box } from '@mui/material';
import { CloudDownload as CloudDownloadIcon } from '@mui/icons-material';
import { Printing } from '../../types';

export const PrintingReportButton = () => {
  const record = useRecordContext<Printing>();

  // Only show button if reportUrl exists
  if (!record?.reportUrl) {
    return null;
  }

  const handleOpen = () => {
    if (record.reportUrl) {
      window.open(record.reportUrl, '_blank');
    }
  };

  return (
    <Box sx={{ mt: 2 }}>
      <InputLabel shrink>Report</InputLabel>
      <Button
        variant="contained"
        color="primary"
        onClick={handleOpen}
        startIcon={<CloudDownloadIcon />}
        sx={{ mt: 1 }}
      >
        Download Report
      </Button>
    </Box>
  );
};
